module.exports = __webpack_public_path__ + "static/media/Content.1d314bae.svg";